import type { MenuConfig } from '~typings/menu'

import permisosCompras, { RESOURCE_COMPRAS } from '@/auth/permissions/modules/compras'
import * as names from '@routes/compras/nombres/configuracion'

const { configuracion } = permisosCompras
export default [
    {
        title: 'compras.subopciones.config_cont_servicios',
        route: names.ROUTE_APROBACION_CONTABLE_SERVICIOS,
        resource: RESOURCE_COMPRAS,
        action: configuracion.aprobacionContableServicios,
    },
    {
        title: 'compras.subopciones.config_trib_servicios',
        route: names.ROUTE_APROBACION_TRIBUTARIA_SERVICIOS,
        resource: RESOURCE_COMPRAS,
        action: configuracion.aprobacionTributariaServicios,
    },
    {
        title: 'compras.subopciones.dueno_categoria',
        route: names.ROUTE_DUENO_CATEGORIA,
        resource: RESOURCE_COMPRAS,
        action: configuracion.duenoCategoria,
    },
    {
        title: 'compras.subopciones.nivel_aprobacion',
        route: names.ROUTE_NIVEL_APROBACION,
        resource: RESOURCE_COMPRAS,
        action: configuracion.nivelAprobacionSolicitud,
    },
    {
        title: 'compras.subopciones.permiso_categoria',
        route: names.ROUTE_PERMISOS_CATEGORIA,
        resource: RESOURCE_COMPRAS,
        action: configuracion.permisoCategoria,
    },
    {
        title: 'compras.subopciones.responsables_aprob_oc',
        route: names.ROUTE_RESPONSABLES_APROBACION_OC,
        resource: RESOURCE_COMPRAS,
        action: configuracion.responsablesAprobacionOC,
    },
] as MenuConfig[]
